module.exports = __webpack_public_path__ + "static/media/code-merge.5531a32b.svg";